import { LISTS_CONSTANTS } from './constants'
import {AuthConstants} from "../auth/constants";

export function lists(
  state = {
    boolean_list: [
      { key: 'key_boolean_list_true', value: true, text: 'Yes' },
      { key: 'key_boolean_list_false', value: false, text: 'No' },
    ],
  },
  action
) {
  switch (action.type) {
    case LISTS_CONSTANTS.GET_LISTS_REQUEST:
      return {
        ...state,
      }
    case LISTS_CONSTANTS.GET_LISTS_SUCCESS: {
      return {
        ...state,
        ...action.response,
      }
    }
    case LISTS_CONSTANTS.GET_LISTS_FAILURE: {
      return {
        ...state,
        ...action.response,
      }
    }
     case AuthConstants.DELETE_AUTH_INFO: {
      return {}
    }

    default:
      return state
  }
}
